import React,{useState,useEffect} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './FileUpload.scss'
import swal from 'sweetalert';
import { faUpload } from '@fortawesome/free-solid-svg-icons'
import { isEmpty } from 'components/Login/validator';


const FileUpload = ({setUploadFiles, setBuildUrl, editResponse,editHandler,setEditFileUpload,setEditProp,setBuildEdit,setChecked,setMultiUploadFiles,ModalformValues,buildInputVal,buildUrl}) => {
    const [disabled, setDisabled] = useState(true)
    if( editResponse !== undefined){
        setUploadFiles(editResponse.builddetails?.['url'])
    }

    const uploadHandler = (event) => {
        const file = event.target.files[0];
        const allowedfileExtensions = ["apk", "msi","exe"];
        editHandler("singleFileUpload")
        setEditProp(true);
        setBuildEdit(1)
        const span = document.createElement("span");
        if(file){
            span.innerHTML = `The specified ${file.type !== "" ? 'file' : 'directory'} <code>${file.name}</code> could not be uploaded`;
             let fileExtension = file.name.match(/\.([^\.]+)$/);
            if(ModalformValues['platform'].value ==='2201' && (fileExtension[1])!== allowedfileExtensions[0]){
                swal({
                    title: 'Please upload .apk files for mobile',
                    content: span,
                    icon: "warning",
                });
            }
           else if(ModalformValues['platform'].value ==='2202' && (fileExtension[1])!== allowedfileExtensions[1]){
                swal({
                    title: 'Please upload .msi files for desktop',
                    content: span,
                    icon: "warning",
                });
            }
            else if(ModalformValues['platform'].value ==='2203' && (fileExtension[1])!== allowedfileExtensions[2]){
                swal({
                    title: 'Please upload .exe files for software',
                    content: span,
                    icon: "warning",
                });
            }
        else {
            setEditFileUpload(true)
            setBuildUrl([file])
            setMultiUploadFiles([])
            setChecked(false)
            setUploadFiles([file])
            }
        }
        event.target.value = '';
       
    }

    useEffect(() => {
        if(!isEmpty(buildInputVal)){
            if(buildInputVal.platform.value !== null && buildInputVal.platform.value !== "Please Select"){
                setDisabled(false)
                if(buildUrl){
                 let file1=buildUrl[0]?.name
                 let fileExtension1=file1?.match(/\.([^\.]+)$/);
                 if(file1){
                if(fileExtension1[1]=== 'apk' && buildInputVal.platform.value!=='2201'){
                    setBuildUrl([])
                    setUploadFiles([])
                    setEditProp(true)
                }
                if(fileExtension1[1]=== 'msi' && buildInputVal.platform.value!=='2202'){
                    setBuildUrl([])
                    setUploadFiles([])
                    setEditProp(true)
                }
                if(fileExtension1[1]=== 'exe' && buildInputVal.platform.value!=='2203'){
                    setBuildUrl([])
                    setUploadFiles([])
                    setEditProp(true)
                }
            }}} else {
                setDisabled(true)
                setUploadFiles([])
                if(buildUrl && buildInputVal.platform.value === "Please Select"){
                    setBuildUrl([])
                   setEditProp(true)
                }
               
            }   
        }
        
    },[buildInputVal])

    return (
        <>
            <div className="file-card">
                <div className="file-inputs ">
                    <input type="file" onChange={uploadHandler} disabled={disabled} />
                    <button
                        disabled={disabled} 
                        style={disabled ? {opacity: "0.1",cursor: "not-allowed"}: {color: "black"}} 
                        className={disabled ? "disabled-styles": ""} >
                        <i>
                            <FontAwesomeIcon icon={faUpload} />
                        </i>
                        Click to Upload
                    </button>
                </div>
            </div>
        </>
    )
}

export default FileUpload;